import * as types from './action-types'

export function uploadTransferredWorkerCsv(file: Object) {
  return { type: types.UPLOAD_TRANSFERRED_WORKER_CSV_BEGIN, file }
}
